import PropTypes from 'prop-types';
import React from 'react';
import ControlledWidthContainer from '../../../Community/Sections/ControlledWidthContainer/ControlledWidthContainer';
import {
    COMPANY_PROPTYPES,
    DEFAULT_COMPANY_PROPS,
} from '../../../Includes/CompanyProps';
import ControlledWidthContainerEightHundred from '../../../Layout/ControlledWidthContainerEightHundred/ControlledWidthContainerEightHundred';
import RowRecord from '../RowRecord/RowRecord';

import './BenefitsContentSection.scss';

export default class BenefitsContentSection extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        company: PropTypes.shape(COMPANY_PROPTYPES),
        /**
         * industry that company belongs to
         */
        industry: PropTypes.string,
        /*
         * url of benefit definition page
         */
        benefitsUrl: PropTypes.string.isRequired,
        /**
         * url endpoint for submitting comments/tips
         */
        submitUrl: PropTypes.string.isRequired,
        /**
         * best company badges
         */
        bestCompaniesBadges: PropTypes.arrayOf(
            PropTypes.shape({
                type: PropTypes.string,
                url: PropTypes.string,
            })
        ),
        /**
         * company rating
         */
        companyRating: PropTypes.number.isRequired,
        /**
         * array of company records
         */
        companyRecords: PropTypes.arrayOf(
            PropTypes.shape({
                /**
                 * what type of benefits
                 */
                fieldName: PropTypes.string.isRequired,
                /**
                 * lowest record
                 */
                low: PropTypes.string,
                /**
                 * median record
                 */
                median: PropTypes.string,
                /**
                 * highest record
                 */
                high: PropTypes.string,
                /**
                 * array of benefit comments
                 */
                comments: PropTypes.array,
                /**
                 * type of policy
                 */
                type: PropTypes.string,
                /**
                 * description of the data, to be displayed on tooltip
                 */
                description: PropTypes.string,
                /**
                 * tip input type
                 */
                tipInputType: PropTypes.oneOf(['dropdown', 'inputBox']),
            })
        ).isRequired,
        /**
         * industrial records
         */
        industryRecords: PropTypes.arrayOf(
            PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.string,
                    description: PropTypes.string,
                })
            )
        ).isRequired,
        /**
         * verified partner data
         */
        verifiedPartnerData: PropTypes.arrayOf(
            PropTypes.shape({
                benefitGroup: PropTypes.string,
                description: PropTypes.shape({
                    type: PropTypes.string,
                    description: PropTypes.string, // string
                }), // html string
                percentage: PropTypes.number, // null if doesn't have it
                subBenefits: PropTypes.arrayOf(
                    PropTypes.shape({
                        type: PropTypes.string,
                        description: PropTypes.string, // string
                    })
                ),
            })
        ), // null if not sponsor
        /**
         * function for submitting comments/tips
         */
        onCommentSubmit: PropTypes.func.isRequired,
    };

    static defaultProps = {
        company: DEFAULT_COMPANY_PROPS,
        industry: '',
        benefitsUrl: '',
        submitUrl: '',
        bestCompaniesBadges: [],
        companyRating: '4.4',
        companyRecords: [],
        industryRecords: [],
        verifiedPartnerData: null,
    };

    renderCompanyTableContents = () => {
        return this.props.companyRecords.map((record, idx) => {
            return (
                <div className="pt-1 pb-1" key={idx}>
                    <RowRecord
                        fieldName={record.fieldName}
                        low={record.low}
                        median={record.median}
                        high={record.high}
                        comments={record.comments}
                        type={record.type}
                        description={record.description}
                        onCommentSubmit={this.props.onCommentSubmit}
                        tipInputType={record.tipInputType}
                    />
                </div>
            );
        });
    };

    render() {
        return (
            <div className="component-Employer-Benefits-BenefitsContentSection">
                <ControlledWidthContainerEightHundred className="common-tip-section">
                    <div className="section-header">
                        Crowdsourced Employer Benefits
                    </div>
                    <ControlledWidthContainer className="">
                        <div className="section">
                            Help other women by leaving an anonymous tip (no
                            sign up required)! We crowdsource employer benefits
                            such as healthcare, PTO and maternity leave so you
                            can make better career decisions.
                        </div>
                        {/* Remove until we know the behavior of this button <Button type="purple-medium-white" className="" value="Leave a tip" onClick={this.props.onCommentSubmit} />*/}
                    </ControlledWidthContainer>
                </ControlledWidthContainerEightHundred>

                <div className="employer-benefits-section">
                    <div className="section-title">Employer Benefits</div>

                    <div className="company-table">
                        <div className="text-center d-none d-md-block">
                            <div className="left-col">
                                <div className="row">
                                    <div className="col-6" />
                                    <div className="col-2">Lower</div>
                                    <div className="col-2">
                                        Median/ Consensus
                                    </div>
                                    <div className="col-2">Upper</div>
                                </div>
                            </div>
                            <div className="right-col">
                                Corrections, Tips & Comments
                            </div>
                        </div>
                        {this.renderCompanyTableContents()}
                    </div>
                </div>
            </div>
        );
    }
}
